import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Localization_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                d="M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 4C17 3.44772 16.5523 3 16 3C15.4477 3 15 3.44772 15 4V5.71443C10.0913 6.1858 6.1858 10.0913 5.71443 15H4C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17H5.71443C6.1858 21.9087 10.0913 25.8142 15 26.2856V28C15 28.5523 15.4477 29 16 29C16.5523 29 17 28.5523 17 28V26.2856C21.9087 25.8142 25.8142 21.9087 26.2856 17H28C28.5523 17 29 16.5523 29 16C29 15.4477 28.5523 15 28 15H26.2856C25.8142 10.0913 21.9087 6.1858 17 5.71443V4ZM7.72605 15C8.18086 11.197 11.197 8.18086 15 7.72605V9.33333C15 9.88562 15.4477 10.3333 16 10.3333C16.5523 10.3333 17 9.88562 17 9.33333V7.72605C20.803 8.18086 23.8191 11.197 24.274 15H22.6667C22.1144 15 21.6667 15.4477 21.6667 16C21.6667 16.5523 22.1144 17 22.6667 17H24.274C23.8191 20.803 20.803 23.8191 17 24.274V22.6667C17 22.1144 16.5523 21.6667 16 21.6667C15.4477 21.6667 15 22.1144 15 22.6667V24.274C11.197 23.8191 8.18086 20.803 7.72605 17H9.33333C9.88562 17 10.3333 16.5523 10.3333 16C10.3333 15.4477 9.88562 15 9.33333 15H7.72605Z"
            />
        </SvgStyled>
    );
};

export default Localization_lg;
